import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Lock body scroll when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeModal]);
  return <>
      <footer className="bg-[#2D2A26] text-white pt-12 pb-8 px-4" data-id="element-1">
        <div className="max-w-4xl mx-auto" data-id="element-2">
          <div className="text-center mb-8" data-id="element-3">
            <p className="font-serif text-xl mb-2" data-id="element-4">Ansiedad Hormonal</p>
            <p className="text-white/40 text-sm" data-id="element-5">Protocolo 14 Días</p>
          </div>

          <div className="w-full h-px bg-white/10 mb-8" data-id="element-6" />

          <div className="flex items-center justify-center gap-6 flex-wrap" data-id="element-7">
            <button onClick={() => setActiveModal('terms')} className="text-sm text-white/60 hover:text-white/90 transition-colors duration-300 underline underline-offset-4 decoration-white/20 hover:decoration-white/50" data-id="element-8">
              Términos y Condiciones
            </button>
            <span className="text-white/20" data-id="element-9">|</span>
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-white/60 hover:text-white/90 transition-colors duration-300 underline underline-offset-4 decoration-white/20 hover:decoration-white/50" data-id="element-10">
              Política de Privacidad
            </button>
          </div>

          <div className="mt-8 text-center" data-id="element-11">
            <p className="text-white/30 text-xs" data-id="element-12">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-13">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-14" />

          {/* Modal Content */}
          <div className="relative bg-[#FDF8F3] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto border border-[#E8DED5]" onClick={e => e.stopPropagation()} data-id="element-15">
            {/* Header */}
            <div className="sticky top-0 bg-[#FDF8F3] border-b border-[#E8DED5] px-6 py-4 flex items-center justify-between rounded-t-2xl z-10" data-id="element-16">
              <h3 className="font-serif text-xl text-[#2D2A26]" data-id="element-17">
                {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full bg-[#E8DED5] flex items-center justify-center text-[#6B6560] hover:bg-[#D4CCC4] hover:text-[#2D2A26] transition-colors" data-id="element-18">
                <X className="w-4 h-4" data-id="element-19" />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-6 text-[#6B6560] text-sm leading-relaxed space-y-4" data-id="element-20">
              {activeModal === 'terms' ? <TermsContent data-id="element-21" /> : <PrivacyContent data-id="element-22" />}
            </div>
          </div>
        </div>}
    </>;
}
function TermsContent() {
  return <>
      <p className="text-[#2D2A26]" data-id="element-23">
        Al adquirir este producto digital, aceptás los siguientes términos:
      </p>
      <p data-id="element-24">
        <span className="text-[#2D2A26] font-medium" data-id="element-25">1. Producto digital.</span>{' '}
        Este es un ebook en formato PDF de descarga instantánea. Una vez
        realizada la compra, recibirás acceso inmediato al material.
      </p>
      <p data-id="element-26">
        <span className="text-[#2D2A26] font-medium" data-id="element-27">2. Uso personal.</span> El
        contenido es para uso personal y no puede ser reproducido, distribuido,
        compartido ni revendido total o parcialmente sin autorización previa.
      </p>
      <p data-id="element-28">
        <span className="text-[#2D2A26] font-medium" data-id="element-29">
          3. No reemplaza atención profesional.
        </span>{' '}
        Este material es informativo y educativo. No constituye diagnóstico,
        tratamiento médico ni psicológico. Si estás en crisis o necesitás
        atención urgente, consultá con un profesional de la salud.
      </p>
      <p data-id="element-30">
        <span className="text-[#2D2A26] font-medium" data-id="element-31">4. Resultados.</span> Los
        resultados pueden variar según cada persona. No se garantizan resultados
        específicos. El contenido ofrece herramientas y protocolos basados en
        evidencia, pero cada experiencia es individual.
      </p>
      <p data-id="element-32">
        <span className="text-[#2D2A26] font-medium" data-id="element-33">
          5. Política de reembolso.
        </span>{' '}
        Dado que se trata de un producto digital de entrega inmediata, no se
        aceptan devoluciones una vez descargado el material.
      </p>
      <p data-id="element-34">
        <span className="text-[#2D2A26] font-medium" data-id="element-35">
          6. Propiedad intelectual.
        </span>{' '}
        Todo el contenido del ebook, incluyendo textos, gráficos, protocolos y
        trackers, está protegido por derechos de autor.
      </p>
      <p data-id="element-36">
        <span className="text-[#2D2A26] font-medium" data-id="element-37">7. Modificaciones.</span>{' '}
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación.
      </p>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-[#2D2A26]" data-id="element-38">
        Tu privacidad es importante. A continuación detallamos cómo manejamos tu
        información:
      </p>
      <p data-id="element-39">
        <span className="text-[#2D2A26] font-medium" data-id="element-40">
          1. Datos que recopilamos.
        </span>{' '}
        Al realizar la compra, se recopilan únicamente los datos necesarios para
        procesar el pago y entregar el producto: correo electrónico y datos de
        pago (procesados por la plataforma de pago, no almacenados por
        nosotros).
      </p>
      <p data-id="element-41">
        <span className="text-[#2D2A26] font-medium" data-id="element-42">2. Uso de los datos.</span>{' '}
        Tu correo electrónico se utiliza exclusivamente para enviarte el
        producto adquirido y, si lo autorizás, comunicaciones relacionadas con
        el contenido. No compartimos tu información con terceros.
      </p>
      <p data-id="element-43">
        <span className="text-[#2D2A26] font-medium" data-id="element-44">
          3. Protección de datos.
        </span>{' '}
        Implementamos medidas de seguridad razonables para proteger tu
        información personal contra acceso no autorizado, alteración o
        destrucción.
      </p>
      <p data-id="element-45">
        <span className="text-[#2D2A26] font-medium" data-id="element-46">4. Cookies.</span> Este
        sitio puede utilizar cookies básicas para mejorar la experiencia de
        navegación. No se utilizan cookies de rastreo publicitario.
      </p>
      <p data-id="element-47">
        <span className="text-[#2D2A26] font-medium" data-id="element-48">
          5. Derechos del usuario.
        </span>{' '}
        Podés solicitar la eliminación de tus datos personales en cualquier
        momento. También podés solicitar acceso a la información que tenemos
        sobre vos.
      </p>
      <p data-id="element-49">
        <span className="text-[#2D2A26] font-medium" data-id="element-50">
          6. Plataformas de pago.
        </span>{' '}
        Los pagos son procesados por plataformas de terceros que cuentan con sus
        propias políticas de privacidad y seguridad. No almacenamos datos de
        tarjetas ni información financiera.
      </p>
      <p data-id="element-51">
        <span className="text-[#2D2A26] font-medium" data-id="element-52">7. Modificaciones.</span>{' '}
        Esta política puede ser actualizada periódicamente. Los cambios serán
        efectivos desde su publicación en esta página.
      </p>
    </>;
}